import React from 'react';
import withBaseComponent from '../../withBaseComponent';
import {connect} from "react-redux";
import {mapDispatchToProps} from "../../mapDispatchToProps"
import LoginHeader from "./LoginHeader"

class OauthAuthorizeLayout extends withBaseComponent(React.Component) {
  componentWillMount() {
    this.props.userActions.getUser()
  }

  render () {
    return (
      <div className='d-flex flex-column login'>
        <LoginHeader />

        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <main>
                {this.props.children}
              </main>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OauthAuthorizeLayout);
